import type { DdjjPropioForm } from '@components/empresas/DdjjOrigenSelector';
import type { DdjjConfigPayload } from '@lib/services/empresas.service';
/**
 * Qué `ddjjConfig` viaja al Guardar según lo elegido en la pestaña:
 *  - cuestionario propio NUEVO (recién importado): las preguntas y su origen;
 *  - volver al catálogo cuando la empresa tenía uno propio: `preguntas: []`
 *    (el server lo toma como "borrar"; sin mandarlo, lo conservaría);
 *  - en cualquier otro caso, solo las exclusiones: el server mergea campo por
 *    campo y un cuestionario propio ya guardado sobrevive.
 */
export function ddjjConfigPayload(
  form: { ddjjExcluidas: string[]; ddjjPropio: DdjjPropioForm | null },
  teniaPropio: boolean,
): DdjjConfigPayload {
  if (form.ddjjPropio?.nuevo) {
    return { preguntas: form.ddjjPropio.preguntas, origen: form.ddjjPropio.origen };
  }
  if (!form.ddjjPropio && teniaPropio) {
    return { preguntasExcluidas: form.ddjjExcluidas, preguntas: [] };
  }
  return { preguntasExcluidas: form.ddjjExcluidas };
}
